import { GPXData, Coordinate } from '../types'

const generateSamplePoints = (
  count: number,
  totalDist: number,
): Coordinate[] => {
  const points: Coordinate[] = []
  const startLat = 45.9237 // Near Chamonix
  const startLon = 6.8694

  let currentLat = startLat
  let currentLon = startLon
  let currentEle = 1035
  let currentDist = 0

  const distStep = totalDist / count

  for (let i = 0; i < count; i++) {
    // Simulate some winding path
    currentLat += (Math.random() - 0.3) * 0.01
    currentLon += (Math.random() - 0.3) * 0.01

    // Simulate elevation: Climb first half, descend second half with noise
    if (i < count * 0.4) {
      currentEle += 20 + Math.random() * 10 // Steep climb
    } else if (i < count * 0.6) {
      currentEle += (Math.random() - 0.5) * 10 // Rolling top
    } else {
      currentEle -= 15 + Math.random() * 10 // Descent
    }

    currentDist = i * distStep

    points.push({
      lat: currentLat,
      lon: currentLon,
      ele: Math.max(0, currentEle),
      distFromStart: currentDist,
    })
  }

  return points
}

const points = generateSamplePoints(200, 25.5)

// Recalculate exact totals based on generated points
let totalGain = 0
let totalLoss = 0
for (let i = 1; i < points.length; i++) {
  const diff = points[i].ele - points[i - 1].ele
  if (diff > 0) totalGain += diff
  else totalLoss += Math.abs(diff)
}

export const SAMPLE_GPX_DATA: GPXData = {
  name: 'Chamonix Trail Demo',
  points: points,
  totalDistance: 25.5,
  totalElevationGain: totalGain,
  totalElevationLoss: totalLoss,
}
